import { container } from '@graphistry/falcor-react-redux';
import { 
    updateCollectionSets, 
    updateCollectionNodeEncoding, 
    updateCollectionEdgeEncoding,
    updateCollectionName,
    toggleCollectionsPanel,
} from '@graphistry/viz/src/actions/collections';

import { CollectionsComponent } from '../../components/collections/index.tsx';


export const CollectionsContainer = container({
    renderLoading: false,
    fragment: (collections) => {
        return `{
            enabled,
            visible,
            length,
            sets: {
                length,
                [0...${collections?.sets?.length ?? 0}]: {
                    id, type, name, description, enabled,
                    node_encoding: {
                        type, color
                    },
                    edge_encoding: {
                        type, color
                    },
                    expr: {
                        type, sets, gfql
                    }
                }
            },
        }`;
    },
    mapFragment(data, props, $falcor) {
        return { ...data, $falcor, ...props };
    },
    dispatchers: {
        onUpdateCollectionSets: updateCollectionSets,
        onUpdateCollectionNodeEncoding: updateCollectionNodeEncoding,
        onUpdateCollectionEdgeEncoding: updateCollectionEdgeEncoding,
        onUpdateCollectionName: updateCollectionName,
        onToggleCollections: toggleCollectionsPanel,
    }
});

export const Collections = CollectionsContainer(CollectionsComponent)